import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import userService from '../../services/UserService';
export const initialState = {
    loading: false,
    message: '',
    list:null,
}
export const AttendenceListAll = createAsyncThunk('health/list',async (data, { rejectWithValue }) => {
    try {
        const response = await userService.getAttendees(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})
export const AttendanceSlice = createSlice({
    name: 'EmployeesAttendence',
    initialState,
    reducers: {
        AttendenceList: (state, action) => {
            state.loading = true
            state.list = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(AttendenceListAll.pending, (state) => {
                state.loading = false
            })
            .addCase(AttendenceListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})
export const {
    AttendenceList,
} = AttendanceSlice.actions
export default AttendanceSlice.reducer